import {useMemo} from "react";

import {IRange} from "@pg-design/inputs-module";
import {useIsMounted} from "@pg-mono/hooks";
import {sum} from "@pg-mono/nodash";

import {ISearchFilter, ISearchFilters} from "../types/ISearchFilters";
import {SearchFilterTypes} from "../types/SearchFilterTypes";
import {SearchFormValuesType} from "../types/SearchFormValuesType";

const countInputRange = (fieldValue?: IRange<string | number>) => {
    let count = 0;

    if (fieldValue?.lower) {
        count++;
    }

    if (fieldValue?.upper) {
        count++;
    }

    return count;
};

const isInputRange = (value: unknown): value is IRange<string | number> => {
    return typeof value == "object";
};

const countRangeCheckbox = <T>(fieldValue: {lower?: T; upper?: T}) => {
    if (!fieldValue.lower && !fieldValue.upper) {
        return 0;
    }

    if (fieldValue.lower === fieldValue.upper || fieldValue.upper === 1 || fieldValue.lower === 5) {
        return 1;
    }

    return 2;
};

const countSelectedFilterOptions = <TSearchFilters>(
    singleFilter: ISearchFilter<keyof TSearchFilters, TSearchFilters[keyof TSearchFilters]>,
    filterValue: TSearchFilters[keyof TSearchFilters]
) => {
    switch (singleFilter.type) {
        case SearchFilterTypes.MULTI_CHECKBOX:
            if (Array.isArray(filterValue)) {
                return filterValue.length;
            } else if (typeof filterValue === "string" && parseInt(filterValue) > 0) {
                return 1;
            }
            return 0;
        case SearchFilterTypes.RADIO:
            if (Array.isArray(filterValue)) {
                return (filterValue as unknown as []).length ? 1 : 0;
            }

            return Number.isFinite(filterValue) || !!filterValue ? 1 : 0;
        case SearchFilterTypes.OFFER_TYPE:
            return Array.isArray(filterValue) && (filterValue as unknown as []).length > 0 ? (filterValue as unknown as []).length : 2;
        case SearchFilterTypes.RANGE:
            return (isInputRange(filterValue) && countInputRange(filterValue)) || 0;
        case SearchFilterTypes.SELECT_RANGE:
            return (isInputRange(filterValue) && countRangeCheckbox(filterValue)) || 0;
        default:
            return 0;
    }
};

const defaultOptions: IUseCountSearchFiltersOptions = {
    fieldsToExclude: ["search", "distance"],
    afterMountOnly: false
};

export interface IUseCountSearchFiltersOptions {
    fieldsToExclude?: (keyof SearchFormValuesType)[];
    afterMountOnly?: boolean;
}

export const useCountSearchFilters = <TSearchFilters>(
    searchFiltersValues: TSearchFilters,
    searchFiltersConfig: ISearchFilters<TSearchFilters>,
    customOptions?: IUseCountSearchFiltersOptions
) => {
    const options = {
        ...defaultOptions,
        ...(customOptions || {})
    };
    const isMounted = useIsMounted();

    const countBySlotFilters = useMemo(() => {
        if (options.afterMountOnly && !isMounted) {
            return {} as Record<string, Record<keyof TSearchFilters, number>>;
        }

        return searchFiltersConfig.slots.reduce(
            (filterSlotCount, filterSlot) => {
                filterSlotCount[filterSlot.id] = filterSlot.filters.reduce(
                    (singleFilterCount, singleFilter) => {
                        singleFilterCount[singleFilter.id] = countSelectedFilterOptions(singleFilter, searchFiltersValues[singleFilter.id]);
                        return singleFilterCount;
                    },
                    {} as Record<keyof TSearchFilters, number>
                );
                return filterSlotCount;
            },
            {} as Record<string, Record<keyof TSearchFilters, number>>
        );
    }, [searchFiltersValues, isMounted]);

    const countBySlots = useMemo(() => {
        return Object.keys(countBySlotFilters).reduce(
            (result, slotKey) => {
                const countByFilters = Object.values(countBySlotFilters[slotKey]) as number[];
                result[slotKey] = sum(countByFilters);

                return result;
            },
            {} as Record<string, number>
        );
    }, [countBySlotFilters]);

    const totalCount = useMemo(() => {
        const slotsCount = Object.values(countBySlots) as number[];

        return sum(slotsCount);
    }, [countBySlots]);

    return {
        totalCount,
        countBySlotFilters,
        countBySlots
    };
};
import {useMemo} from "react";

import {IRange} from "@pg-design/inputs-module";
import {useIsMounted} from "@pg-mono/hooks";
import {sum} from "@pg-mono/nodash";

import {ISearchFilter, ISearchFilters} from "../types/ISearchFilters";
import {SearchFilterTypes} from "../types/SearchFilterTypes";
import {SearchFormValuesType} from "../types/SearchFormValuesType";

const countInputRange = (fieldValue?: IRange<string | number>) => {
    let count = 0;

    if (fieldValue?.lower) {
        count++;
    }

    if (fieldValue?.upper) {
        count++;
    }

    return count;
};

const isInputRange = (value: unknown): value is IRange<string | number> => {
    return typeof value == "object";
};

const countRangeCheckbox = <T>(fieldValue: {lower?: T; upper?: T}) => {
    if (!fieldValue.lower && !fieldValue.upper) {
        return 0;
    }

    if (fieldValue.lower === fieldValue.upper || fieldValue.upper === 1 || fieldValue.lower === 5) {
        return 1;
    }

    return 2;
};

const countSelectedFilterOptions = <TSearchFilters>(
    singleFilter: ISearchFilter<keyof TSearchFilters, TSearchFilters[keyof TSearchFilters]>,
    filterValue: TSearchFilters[keyof TSearchFilters]
) => {
    switch (singleFilter.type) {
        case SearchFilterTypes.MULTI_CHECKBOX:
            if (Array.isArray(filterValue)) {
                return filterValue.length;
            } else if (typeof filterValue === "string" && parseInt(filterValue) > 0) {
                return 1;
            }
            return 0;
        case SearchFilterTypes.RADIO:
            if (Array.isArray(filterValue)) {
                return (filterValue as unknown as []).length ? 1 : 0;
            }

            return Number.isFinite(filterValue) || !!filterValue ? 1 : 0;
        case SearchFilterTypes.OFFER_TYPE:
            return Array.isArray(filterValue) && (filterValue as unknown as []).length > 0 ? (filterValue as unknown as []).length : 2;
        case SearchFilterTypes.RANGE:
            return (isInputRange(filterValue) && countInputRange(filterValue)) || 0;
        case SearchFilterTypes.SELECT_RANGE:
            return (isInputRange(filterValue) && countRangeCheckbox(filterValue)) || 0;
        default:
            return 0;
    }
};

const defaultOptions: IUseCountSearchFiltersOptions = {
    fieldsToExclude: ["search", "distance"],
    afterMountOnly: false
};

export interface IUseCountSearchFiltersOptions {
    fieldsToExclude?: (keyof SearchFormValuesType)[];
    afterMountOnly?: boolean;
}

export const useCountSearchFilters = <TSearchFilters>(
    searchFiltersValues: TSearchFilters,
    searchFiltersConfig: ISearchFilters<TSearchFilters>,
    customOptions?: IUseCountSearchFiltersOptions
) => {
    const options = {
        ...defaultOptions,
        ...(customOptions || {})
    };
    const isMounted = useIsMounted();

    const countBySlotFilters = useMemo(() => {
        if (options.afterMountOnly && !isMounted) {
            return {} as Record<string, Record<keyof TSearchFilters, number>>;
        }

        return searchFiltersConfig.slots.reduce(
            (filterSlotCount, filterSlot) => {
                filterSlotCount[filterSlot.id] = filterSlot.filters.reduce(
                    (singleFilterCount, singleFilter) => {
                        singleFilterCount[singleFilter.id] = countSelectedFilterOptions(singleFilter, searchFiltersValues[singleFilter.id]);
                        return singleFilterCount;
                    },
                    {} as Record<keyof TSearchFilters, number>
                );
                return filterSlotCount;
            },
            {} as Record<string, Record<keyof TSearchFilters, number>>
        );
    }, [searchFiltersValues, isMounted]);

    const countBySlots = useMemo(() => {
        return Object.keys(countBySlotFilters).reduce(
            (result, slotKey) => {
                const countByFilters = Object.values(countBySlotFilters[slotKey]) as number[];
                result[slotKey] = sum(countByFilters);

                return result;
            },
            {} as Record<string, number>
        );
    }, [countBySlotFilters]);

    const totalCount = useMemo(() => {
        const slotsCount = Object.values(countBySlots) as number[];

        return sum(slotsCount);
    }, [countBySlots]);

    return {
        totalCount,
        countBySlotFilters,
        countBySlots
    };
};
